import React from "react";
import ProjectComponent from "../components/project/project.component";

export default function Project() {
    return (
        <ProjectComponent />
    )
}